export enum ActivityLogStatus {
  CREATED = 'CREATED',
  CREATED_BY_LLM = 'CREATED_BY_LLM',
  UPDATED = 'UPDATED',
}

export enum ActivityLogEntityType {
  INBOX_ENTRY = 'INBOX_ENTRY',
  INBOX_ENTRY_COMMENT = 'INBOX_ENTRY_COMMENT',
  RECURRENCE_INBOX_ENTRY = 'RECURRENCE_INBOX_ENTRY',
  HOT_TOPIC = 'HOT_TOPIC',
  TASK_GROUP = 'TASK_GROUP',
  TASK_LABEL = 'TASK_LABEL',
  TASK_SUBGROUP = 'TASK_SUBGROUP',
  TEAM = 'TEAM',
  TEAM_INVITE = 'TEAM_INVITE',
  USER_COMMUNICATION = 'USER_COMMUNICATION',
}

export interface ActivityLogChange {
  key: string;
  oldValue: string;
  newValue: string;
}

export interface ActivityLogRecord {
  // Accepted-key exception (2026-09 pre-SOC2 audit): the table's partition key.
  // For ActivityLogEntityType.TEAM_INVITE rows it is `teamInviteStore.createEntityId(teamId, userEmail)`,
  // so ~44 rows carry an invitee's email address in the PK. Every read
  // (`KeyConditionExpression: 'entityId = :entityId'`) is an exact-match lookup
  // against this value, and envelope ciphertext is per-row random — sealing it
  // would turn every one of those lookups into a miss. Same accepted class as
  // `HTUsers.Email` / `HTTeamsInvites.inviteeEmail` (see .claude/rules/backend/encryption.md).
  entityId: string;
  timestampId: string;
  userName?: string;
  userId?: string;
  status: ActivityLogStatus;
  changes?: ActivityLogChange[];
  entityType: ActivityLogEntityType;
  createdAt: number;
}

export interface PaginatedActivityLogsResponse {
  activityLogs: ActivityLogRecord[];
  exclusiveStartKey: string | null;
}
